'use client';

/**
 * These are third-party packages with no `'use client'` directive of their
 * own and no source we can add one to — re-exported here behind one
 * boundary so Server Components can render them without forking their
 * contents. Anything we own should declare `'use client'` itself instead of
 * being added here.
 */
export { default as Carousel } from '@carvana/ds-carousel';
export { default as Tooltip } from '@carvana/ds-tooltip';
